<template>
  <component
    :is="clickableComponent"
    v-if="target?.url || actionLinkHandler"
    class="group relative cursor-pointer bg-transparent p-0 text-left "
    :class="{ 'flex items-center gap-x-1 ': icon || src }"
    v-bind="clickableAttrs"
    @click="handleClick"
  >
    <vf-icon v-if="icon || src" :dir :name="icon" :src />
    <span v-if="$feature.showTitleHtml" v-html="titleHtml" class="underscore-base group-hover:underscore-on" />
    <span v-else class="underscore-base group-hover:underscore-on">{{ title }}</span>
  </component>
  <div v-else>
    <component :is="titleComponent" v-if="title" class="fw-bold " v-bind="dataAttrs">
      <span v-if="$feature.showTitleHtml" v-html="titleHtml" />
      <span v-else>{{ title }}</span>
    </component>
    <cms-rich-text v-if="richText" :content="{ richText }" />
  </div>
</template>

<script lang="ts" setup>
import type { Icon } from '#types/target'
import { BaseButton, BaseLink } from '#components'

const props = defineProps<{
  content: any
}>()

const { $gtm } = useNuxtApp()
const { getActionLinkHandler } = useCmsActionLink('footer:link')

const {
  target,
  title,
  titleHtml,
  richText,
  icon: { icon, dir, src } = {} as Icon,
  name,
  delocalizedTracking,
  footerItemL1
} = props.content

const actionLinkHandler = getActionLinkHandler(target, title)
const isFeedback = target?.behavior === 'feedback'
const clickableComponent = computed(() => target?.url ? BaseLink : BaseButton)
const titleComponent = computed(() => isFeedback ? BaseButton : 'p')
const clickableAttrs = computed(() => target?.url
  ? {
      target: target.targetAttribute,
      to: target.url,
    }
  : {})
const trackingLabel = (delocalizedTracking || name || '').replace(/^(?:(?:Footer|L\d+)\s*-\s*)+/i, '').trim()

const handleClick = () => {
  $gtm.push('footer.onClickFooterLink', `${footerItemL1} | ${trackingLabel}`)
  actionLinkHandler?.()
}

const dataAttrs = {
  ...(isFeedback
    ? {
        'data-medallia': target.actionLink?.formId || '',
      }
    : {})
}
</script>
